import { RULE_MESSAGE_TYPE, RULE_STATUS } from '../../../../../../rule-engine/rules/models';

export enum DESKTOP_RULE_SET {
	INSIDE_MAPS = 'InsideMaps',
	DESKTOP = 'Desktop'
}

export class RuleWorkFlow {
	filteredRuleViolations: any[];
	section: RULE_WORKFLOW_SECTION;
	selectedRule: RuleWorkFlowSelectedRule;
	disabledActions: boolean;
	availableRulesOf: RuleWorkFlowAvailableRulesOf;
	rulesShown: number;
	newComment: string;
	newRule: RuleWorkFlowNewRule;
	newStip: RuleWorkFlowNewStip;
	processing: boolean;
	ruleUpdate: RuleWorkFlowRuleUpdate;

	constructor() {
		this.filteredRuleViolations = [];
		this.section = RULE_WORKFLOW_SECTION.CLOSED;
		this.selectedRule = new RuleWorkFlowSelectedRule();
		this.disabledActions = false;
		this.availableRulesOf = new RuleWorkFlowAvailableRulesOf();
		this.rulesShown = 0;
		this.newComment = '';
		this.newRule = new RuleWorkFlowNewRule();
		this.newStip = new RuleWorkFlowNewStip();
		this.processing = false;
		this.ruleUpdate = new RuleWorkFlowRuleUpdate();
	}
}

export enum RULE_WORKFLOW_SECTION {
	CLOSED,
	LIST,
	DETAIL,
	STIPS,
	STIPS_LIST,
	COMMENT,
	COMMENT_LIST,
	NEW
}

export class RuleWorkFlowSelectedRule {
	index: number;
	ruleName: string; // The internal Rule ID
	ruleSetDisplayText: string;
	ruleSetId: string;
	ruleSetName: string;
	availableStips: any[]; // Stips to add
	stips: any[]; // Stips added
	messageType: RULE_MESSAGE_TYPE; // RULE_MESSAGE_TYPE
	displayText: string; // The error
	notes: any[]; // comments
	reason: string;
	status: string;

	constructor() {
		this.index = 0;
		this.ruleName = '';
		this.ruleSetDisplayText = '';
		this.ruleSetId = '';
		this.ruleSetName = '';
		this.availableStips = [];
		this.stips = [];
		this.messageType = null;
		this.displayText = '';
		this.notes = [];
		this.reason = '';
		this.status = '';
	}
}

export class RuleWorkFlowAvailableRulesOf {
	Info: number;
	Warning: number;
	Error: number;

	constructor() {
		this.Info = 0;
		this.Warning = 0;
		this.Error = 0
	}
}

export class RuleWorkFlowNewRule {
	title: string;
	description: string;
	messageType: RULE_MESSAGE_TYPE;
	sortId: number;

	constructor() {
		this.title = '';
		this.description = '';
		this.messageType = RULE_MESSAGE_TYPE.Info;
		this.sortId = 0;
	}
}

export class RuleWorkFlowNewStip {
	stipId: string;
	stipulation: string;

	constructor() {
		this.stipId = null;
		this.stipulation = '';
	}
}

export class RuleWorkFlowRuleUpdate {
	name: string;
	status: RULE_STATUS;

	constructor() {
		this.name = '';
		this.status = null;
	}
}